const RUN_KEY = 'bp-workflow-run'
export const RUNNING_CLASS = 'bp-workflow-running'
const BUILDING_PARAMS = ['id', 'bpId']
const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}'

export const fillRoute = (pattern, ctx = {}) => String(pattern || '').replace(/:([A-Za-z]+)(?:\?(?![A-Za-z_]))?/g, (match, name) => (
  BUILDING_PARAMS.includes(name) && ctx.bpId ? ctx.bpId : match
))

export const routePath = pattern => {
  const value = String(pattern || '')
  const queryStart = value.search(/\?(?=[A-Za-z_][\w-]*=)/)
  return queryStart === -1 ? value : value.slice(0, queryStart)
}

export const hasUnfilledParams = path => /\/:[A-Za-z]/.test(routePath(path))

export const stripOptionalParams = path => String(path || '').replace(/\/:[A-Za-z]+\?(?![A-Za-z_])/g, '')

export const isWorkflowRunning = () => {
  try {
    return document.documentElement.classList.contains(RUNNING_CLASS)
  } catch (e) {
    return false
  }
}

export const parseAdvance = advance => {
  if (!advance || advance === 'next') return { type: 'next' }
  if (advance === 'click') return { type: 'click' }
  const [type, ...rest] = String(advance).split(':')
  const value = rest.join(':')
  if (type === 'route' && value) return { type: 'route', pattern: value }
  if (type === 'appear' && value) return { type: 'appear', anchor: value }
  return { type: 'next' }
}

export const bpIdFromPath = pathname => {
  const match = String(pathname || '').match(new RegExp(`^/(?:bp-list|drafts|favourites)/(${UUID})(?:/|$)`, 'i'))
  return match ? match[1] : null
}

export const startRun = (workflow, ctx = {}) => ({
  key: workflow.key,
  version: workflow.version || 1,
  stepIndex: 0,
  stepCount: (workflow.steps || []).length,
  ctx: { bpId: ctx.bpId || null },
  userId: ctx.userId || null,
  phase: workflow.needs?.building && !ctx.bpId ? 'choosing' : 'locating',
})

export const runReducer = (state, action) => {
  if (action.type === 'start') return startRun(action.workflow, action.ctx)
  if (action.type === 'resume') return action.run ? { ...action.run, phase: action.run.phase === 'choosing' ? 'choosing' : 'locating' } : null
  if (!state) return state
  switch (action.type) {
    case 'chooseBuilding':
      return { ...state, ctx: { ...state.ctx, bpId: action.bpId }, phase: 'locating' }
    case 'located':
      if (action.from !== undefined && action.from !== state.stepIndex) return state
      return { ...state, phase: 'showing' }
    case 'relocate':
      if (action.from !== state.stepIndex || state.phase !== 'showing') return state
      return { ...state, phase: 'locating' }
    case 'missing':
      return { ...state, phase: 'missing' }
    case 'advance':
      if (action.from !== undefined && action.from !== state.stepIndex) return state
      return { ...state, stepIndex: state.stepIndex + 1, phase: 'locating' }
    case 'back':
      return state.stepIndex > 0 ? { ...state, stepIndex: state.stepIndex - 1, phase: 'locating' } : state
    case 'stop':
      return null
    default:
      return state
  }
}

export const isFinished = run => !!run && run.stepIndex >= run.stepCount

export const saveRun = run => {
  try {
    window.sessionStorage.setItem(RUN_KEY, JSON.stringify(run))
  } catch (e) {
    return undefined
  }
  return undefined
}

export const loadRun = () => {
  try {
    const raw = window.sessionStorage.getItem(RUN_KEY)
    return raw ? JSON.parse(raw) : null
  } catch (e) {
    return null
  }
}

export const clearRun = () => {
  try {
    window.sessionStorage.removeItem(RUN_KEY)
  } catch (e) {
    return undefined
  }
  return undefined
}
